import React,{useEffect,useState} from 'react'
import { graphData } from '../../sdk'
import { Loader } from '../Default'

export const RealTimeBlocks=(props) =>{
	const [state,setState]=useState({loader:true});
	const realimeData=async()=>{
		try{
		  let result=await new graphData().getRealTimeDataFr();
		
		   setState((pre)=>{
			return {...pre,...result,loader:false}
		   })
	
		}catch(e){
	    alert("click ok to continue")
		}
	  }
	  useEffect(()=>{
	  realimeData()
	  const setTime=setInterval(()=>realimeData(),1000 *60)
	  return ()=>{
		clearInterval(setTime)
	  }
	  },[])
	  if(!state.loader){
	  return (<>
		<div className="col-xl-3 col-lg-6">
								 
								 <div className="card mb-3">
									 
									 <div className="card-body" >
									  
										 <div className="d-flex fw-bold small mb-3">
											 <span className="flex-grow-1">Employee Detected  
										    </span>
											<span className='fw-bold' style={{fontSize:"20px",color:"white"}}>{state.count}</span>
										 
										 </div>
									 
										
									 </div>
								 
									 <div className="card-arrow">
									 <div className="card-arrow-top-left"></div>
										 <div className="card-arrow-top-right"></div>
										 <div className="card-arrow-bottom-left"></div>
										 <div className="card-arrow-bottom-right"></div>
									 </div>
								 
								 </div>
							 
							 </div>		
							 <div className="col-xl-3 col-lg-6">
								 
								 <div className="card mb-3">
									 
									 <div className="card-body" >
									  
										 <div className="d-flex fw-bold small mb-3">
											 <span className="flex-grow-1">Employee Occupancy</span>
											 <span className='fw-bold' style={{fontSize:"20px",color:"white"}}>{state.occupancy}</span>
										 
										 </div>
									 
										
									 </div>
								 
									 <div className="card-arrow">
									 <div className="card-arrow-top-left"></div>
										 <div className="card-arrow-top-right"></div>
										 <div className="card-arrow-bottom-left"></div>
										 <div className="card-arrow-bottom-right"></div>
									 </div>
								 
								 </div>
							 
							 </div>		
							 <div className="col-xl-3 col-lg-6">
								 
								 <div className="card mb-3">
									 
									 <div className="card-body" >
									  
										 <div className="d-flex fw-bold small mb-3">
											 <span className="flex-grow-1">Vistor FootFall</span>
											 <span className='fw-bold' style={{fontSize:"20px",color:"white"}}>{state.mallCount}</span>
										 </div>
									 
										
									 </div>
								 
									 <div className="card-arrow">
									 <div className="card-arrow-top-left"></div>
										 <div className="card-arrow-top-right"></div>
										 <div className="card-arrow-bottom-left"></div>
										 <div className="card-arrow-bottom-right"></div>
									 </div>
								 
								 </div>
							 
							 </div>		
							 <div className="col-xl-3 col-lg-6">
								 
								 <div className="card mb-3">
									 
									 <div className="card-body" >
									  
										 <div className="d-flex fw-bold small mb-3">
											 <span className="flex-grow-1">Clean FootFall</span>
											 <span className='fw-bold' style={{fontSize:"20px",color:"white"}}>{state.cleanCount}</span>
										 </div>
									 
										
									 </div>
								 
									 <div className="card-arrow">
									 <div className="card-arrow-top-left"></div>
										 <div className="card-arrow-top-right"></div>
										 <div className="card-arrow-bottom-left"></div>
										 <div className="card-arrow-bottom-right"></div>
									 </div>
								 
								 </div>
							 
							 </div>		
							 	
		</>)
	
	  }
	  else{
		return (<>
		<Loader/>
		</>)
	  }
	
    
}
